module.exports = __webpack_public_path__ + "img/eye-crossed.ea4fdb3.svg";